import React from 'react';
import ResponsiveOverlay, {
  type OverlayPresentation,
} from '@/components/ResponsiveOverlay/ResponsiveOverlay';
import './ModalOverlay.css';

interface Props {
  children?: React.ReactNode;
  onClose?: () => void;
  isClosing?: boolean;
  animate?: boolean;
  position?: 'center' | 'right-side';
  className?: string;
  presentation?: OverlayPresentation;
  keyboardAware?: boolean;
  showSheetHandle?: boolean;
  unwrapped?: boolean;
  panelClassName?: string;
}

/**
 * @deprecated Prefer ResponsiveOverlay directly. Thin wrapper for backward compatibility.
 */
const ModalOverlay: React.FC<Props> = ({
  children,
  onClose,
  isClosing = false,
  animate = false,
  position = 'center',
  className = '',
  presentation = 'sheet',
  keyboardAware,
  showSheetHandle,
  unwrapped,
  panelClassName,
}) => (
  <ResponsiveOverlay
    onClose={onClose}
    isClosing={isClosing}
    animate={animate}
    position={position}
    className={className}
    presentation={presentation}
    keyboardAware={keyboardAware}
    showSheetHandle={showSheetHandle}
    unwrapped={unwrapped}
    panelClassName={panelClassName}
  >
    {children}
  </ResponsiveOverlay>
);

export default ModalOverlay;
